import React from 'react';
import { Button, Result, Typography } from 'antd';

const { Paragraph, Text } = Typography;

export default function AlertaErro({ mensagemErro, stackErro = '' }) {
  return (
    <Result
      status="error"
      title="Ocorreu um erro"
      subTitle={mensagemErro}
      extra={[
        <Button type="primary" key="voltar" onClick={() => { window.history.back(); }}>
          Voltar
        </Button>,
        <Button key="tentarNovamente" onClick={() => { window.location.reload(); }}>Tentar novamente</Button>,
      ]}
    >
      {process.env.development && (
      <div className="desc">
        <Paragraph>
          <Text
            strong
            style={{
              fontSize: 16,
            }}
          >
            {stackErro}
          </Text>
        </Paragraph>
      </div>
      )}
    </Result>
  );
}
